import { TaxiReservationApiTaxiReservationUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiReservationUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiReservationApiTaxiReservationUpdateRequest, config) =>
      appApiClient.taxiReservationApi.taxiReservationUpdate(req, config),
  });
